import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HookSection() {
  return <section className="bg-cream text-charcoal py-24 px-6" data-id="element-103">
      <div className="max-w-4xl mx-auto text-center" data-id="element-104">
        <FadeIn data-id="element-105">
          <div className="w-16 h-1 bg-copper mx-auto mb-10" data-id="element-106"></div>
          <p className="text-2xl md:text-3xl font-serif leading-relaxed italic text-charcoal/90" data-id="element-107">
            "Si te has sentido traicionada por tu propio cuerpo al despertar con
            cansancio crónico y una inflamación abdominal que no cede ni con
            'dietas saludables', este mensaje es para ti."
          </p>
          <p className="mt-8 text-lg text-charcoal/70 max-w-2xl mx-auto" data-id="element-108">
            No es falta de voluntad, es un cambio hormonal que requiere una
            nueva estrategia móvil, práctica y efectiva.
          </p>
        </FadeIn>
      </div>
    </section>;
}